import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../../web/components-v2/Theme/theme';
import { FontFamilies } from '../../../web/styles/styles';
import { brandPrimaryHover, brandPrimaryLight, green, white, destructive, statusStripTrack } from '../../styles/colors';
import { aidaBaseStyles } from '../../styles/styles';

const toneRed = '#FF7888';
// Coffee bundles each Lexend weight as its own family, so the weight is picked by name.
const lexendSemiBold = 'Lexend-SemiBold, Lexend, OpenSans, sans-serif';
const lexendMedium = 'Lexend-Medium, Lexend, OpenSans, sans-serif';
const toneYellow = '#F3CE0D';

export const styleSheet = StyleSheet.create({
	blitzPlayLightning1: {
		height: 40,
		left: -15,
		position: 'absolute',
		top: -12,
	},
	blitzPlayLightning2: {
		height: 55,
		position: 'absolute',
		right: -40,
		top: -10,
	},
	demosContainer: {
		...aidaBaseStyles.flexHorizontalCenter,
	},
	green: {
		color: green,
	},
	label: {
		color: brandPrimaryLight,
		font: lexendMedium,
		fontSize: 12,
		paddingLeft: SPACE[8],
	},
	lion: {
		':not(:last-child)': {
			marginRight: 5,
		},
		height: 25,
		width: 25,
	},
	red: {
		color: toneRed,
	},
	pacingStat: {
		alignItems: 'flex-start',
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
		justifyContent: 'center',
		padding: '0 20px',
	},
	pacingTop: {
		alignItems: 'baseline',
		display: 'flex',
		gap: SPACE[8],
	},
	pacingGoal: {
		color: brandPrimaryLight,
		font: lexendMedium,
		fontSize: '12px',
		fontVariantNumeric: 'tabular-nums',
		whiteSpace: 'nowrap',
	},
	pacingTrack: {
		background: statusStripTrack,
		borderRadius: 2,
		height: 4,
		position: 'relative',
		width: 132,
	},
	pacingFill: {
		borderRadius: 2,
		bottom: 0,
		left: 0,
		position: 'absolute',
		top: 0,
		transition: 'width 0.3s',
	},
	pacingTick: {
		background: white,
		borderRadius: 1,
		bottom: -3,
		marginLeft: -1,
		position: 'absolute',
		top: -3,
		width: 2,
	},
	fillGreen: {
		background: green,
	},
	fillYellow: {
		background: toneYellow,
	},
	fillRed: {
		background: toneRed,
	},
	startABlitzButton: {
		background: brandPrimaryHover,
		borderRadius: 20,
		color: white,
		height: 36,
		textAlign: 'center',
		width: 114,
	},
	startABlitzContainer: {
		position: 'absolute',
		right: 40,
	},
	stat: {
		font: lexendSemiBold,
		fontSize: 20,
		fontVariantNumeric: 'tabular-nums',
		transition: 'color .3s ease-in-out',
	},
	statContainer: {
		':not(:last-child)': {
			borderRight: `1px solid ${brandPrimaryHover}`,
		},
		...aidaBaseStyles.flexHorizontalCenter,
		padding: '0 20px',
	},
	statsContainer: {
		...aidaBaseStyles.flexHorizontalCenter,
	},
	statusBannerContainer: {
		...aidaBaseStyles.flexCenter,
		flex: 1,
		height: 60,
		// Tyson Mode and Start a Blitz are absolutely positioned from the banner's right edge.
		position: 'relative',
	},
	statusBannerContent: {
		...aidaBaseStyles.flexCenter,
		justifyContent: 'space-evenly',
		maxWidth: 1400,
		width: '95%',
	},
	tysonModeButton: {
		background: '#89C947', // Same green as direct line call button
		borderRadius: 20,
		color: white,
		height: 36,
		textAlign: 'center',
		width: 130,
		...aidaBaseStyles.flexCenter,
		transition: 'all 0.3s ease',
		':hover': {
			background: '#7AB33D', // Slightly darker green on hover
		},
	},
	tysonModeButtonActive: {
		background: '#333333', // Charcoal for Exit mode
		':hover': {
			background: '#1A1A1A', // Darker charcoal on hover
		},
	},
	tysonModeContainer: {
		position: 'absolute',
		right: 170,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	tysonModeContainerNoBlitz: {
		position: 'absolute',
		right: 40,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	tysonModeIcon: {
		marginRight: 8,
		height: 16,
		width: 16,
	},
	tysonModeIndicator: {
		position: 'absolute',
		top: 42,
		background: destructive,
		borderRadius: 12,
		padding: '4px 8px',
		animation: 'pulse 2s infinite',
	},
	tysonModeIndicatorText: {
		color: white,
		fontSize: '10px',
		font: FontFamilies.semiBold,
		whiteSpace: 'nowrap',
	},
	yellow: {
		color: toneYellow,
	},
});
